import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobefontsComponent } from './simple-icons-adobefonts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobefontsComponent ],
    exports:      [ SimpleIconsAdobefontsComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobefontsModule {}
